module.exports = __webpack_public_path__ + "static/media/Brewery_Information_gradient.b6e690dd.png";